import React, {useState,useEffect} from "react";
import axios from 'axios';
import jwt_decode from "jwt-decode";
import {useNavigate} from "react-router-dom";

const RegisterUser = () => {
    const [namaSpv, setNamaSpv] = useState("");
    const [jabatan, setJabatan] = useState("");
    const [kantor, setKantor] = useState("");
    const [token, setToken] = useState("");
    const [expire, setExpire] = useState("");
    const [msg, setMsg] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        refreshToken();
    },[]);

    const refreshToken = async() => {
        try {
              const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/token`);
              setToken(response.data.accessToken);
              const decoded = jwt_decode(response.data.accessToken);
              setExpire(decoded.exp);
              if (decoded.role === "admin") {
                navigate("/")
                }
              
        } catch (error) {
            if(error.response){
              navigate("/login");
            }
        }
      }
      
      const axiosJWT = axios.create();
      
      axiosJWT.interceptors.request.use(async(config) => {
          const curretDate = new Date();
          if(expire * 1000 < curretDate.getTime()){
              const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/token`);
              config.headers.Authorization = `Bearer ${response.data.accessToken}`;
              setToken(response.data.accessToken);
              const decoded = jwt_decode(response.data.accessToken);
              setExpire(decoded.exp);
          }
          return config;
      }, (error) => {
          return Promise.reject(error);
      });
      
      // ----END---

    const saveRegister = async (e) =>{
        e.preventDefault();
        let formData = new FormData();
            formData.append('namaSpv',namaSpv);
            formData.append('jabatan',jabatan);
            formData.append('kantor',kantor);
        try {
            await axios.post(`${process.env.REACT_APP_MASTER_URL}/spvusers`,formData,{
                headers:{ 
                    'Content-Type':'multipart/form-data'
                }
            });
            navigate("/spvusers")
        } catch (error) {
            if(error.response){
               setMsg(error.response.data.msg);
            }   
        }  
    }

  return (
    <section className="hero has-background-grey-light is-fullheight is-fullwidth">
      <div className="hero-body">
        <div className="container">
            <div className="columns is-centered">
                <div className="column is-4-desktop">
                    <form className="box" onSubmit={saveRegister}>
                        <p style={{color:"red"}} className="has-text-centered">{msg}</p>
                        <div className="filed mt-5">
                                <label className="label">Nama Supervisor</label>
                                <div className="controls">
                                    <input required type="text" className="input" value={namaSpv} onChange={(e)=> setNamaSpv(e.target.value)} placeholder="Nama Spv"/>
                                </div>
                            </div>
                        <div className="filed mt-5">
                            <label className="label">Jabatan</label>
                            <div className="controls">
                                <input required type="text" className="input" value={jabatan} onChange={(e)=> setJabatan(e.target.value)} placeholder="Jabatan"/>
                            </div>
                        </div>
                        <div className="filed mt-5">
                            <label className="label">Cabang</label>
                            <div className="controls">
                                <div className='select is-fullwidth'>
                                    <select required value={kantor} onChange={(e)=> setKantor(e.target.value)}>
                                        <option value=''>--Silahkan Pilih--</option>
                                        <option value="Wlingi">Wlingi</option>
                                        <option value="Kepanjen">Kepanjen</option>
                                        <option value="Brondong">Brondong</option>
                                        <option value="Gresik">Gresik</option>
                                        <option value="Tuban">Tuban</option>
                                        <option value="Ngadiluwih">Ngadiluwih</option>
                                        <option value="Ngunut">Ngunut</option>
                                        <option value="Situbondo">Situbondo</option>
                                        <option value="Genteng">Genteng</option>
                                        <option value="Rambipuji">Rambipuji</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="filed mt-5">
                            <button className="button is-link is-fullwidth">Register</button>
                        </div>
                    </form>
                </div>

            </div>
          
        </div>
      </div>
    </section>
  )
}

export default RegisterUser